export default "__VITE_ASSET__552a75ef__"